import React from 'react';
import styled from 'styled-components';
import { compose } from 'recompose';
import { withToggle } from '../../../hoc';
import { CSSTransition } from 'react-transition-group';

const enchance = compose(withToggle(false));

const MenuWithToggleView = ({ button, render, toggled, toggle }) => (
  <MenuContainer>
    <ButtonContainer>{button(toggle)}</ButtonContainer>

    <CSSTransition timeout={300} classNames="opacity" unmountOnExit in={toggled}>
      <Fade visible={true} onClick={toggle} />
    </CSSTransition>

    <CSSTransition timeout={300} classNames="slide-down-opacity" unmountOnExit in={toggled}>
      <RenderContainer>{render(toggle)}</RenderContainer>
    </CSSTransition>
  </MenuContainer>
);

export const MenuWithToggle = enchance(MenuWithToggleView);

const MenuContainer = styled.div`
  position: relative;
`;

const ButtonContainer = styled.div``;

const RenderContainer = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1011;
`;

const Fade = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: ${(p) => p.visible && 'rgba(0, 0, 0, 0.2)'};
  z-index: 1010;
`;
